import angular from 'angular';

/* 
    The purpose of this directive is to adjust floating points without such
    wondrous behaviour like 0.2 + 0.1 = 0.3000000000000000003 and other misc
    IEEE 754 shenanigans that in no way are making me bald younger.
*/

export default function AdjustDirective(){
    "ngInject"
    return {
        scope: {
            model: "=",
            property: "=",
            min: "="
        },
        link: (scope, el, attr, $ctrl) => {
            el.on('click', () => {
                let value = scope.model[scope.property] || 0;
                if (angular.isDefined(attr.increase)) {
                    value += parseFloat(attr.step);
                } else if (angular.isDefined(attr.decrease)) {
                    value -= parseFloat(attr.step);
                }
                const rounded =  parseFloat(value.toPrecision(3));    
                scope.$apply(() => {
                    scope.model[scope.property] = angular.isDefined(scope.min) && rounded < scope.min ? scope.min : rounded;
                });
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/directives/adjust.directive.js